<template>
    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 10.5L1 5.5L6 0.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11 5.49997H1" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>